import React from 'react';

function HeartsSettingsFields({
  settings = {},
  onChange,
  disabled = false,
  idPrefix = 'hearts',
}) {
  const winAt = settings.winAt ?? 100;
  const moonMode = settings.moonMode === 'subtract' ? 'subtract' : 'shoot_moon';
  const jackOfDiamondsBonus = !!settings.jackOfDiamondsBonus;

  const patch = (partial) => {
    onChange?.({
      winAt,
      moonMode,
      jackOfDiamondsBonus,
      ...partial,
    });
  };

  return (
    <div className="spades-settings-fields hearts-settings-fields">
      <label className="spades-host-setting" htmlFor={`${idPrefix}-winAt`}>
        <span>Play to (lowest wins)</span>
        <select
          id={`${idPrefix}-winAt`}
          value={winAt}
          disabled={disabled}
          onChange={(e) => patch({ winAt: Number(e.target.value) })}
        >
          {[50, 75, 100, 150, 200].map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </label>
      <label className="spades-host-setting" htmlFor={`${idPrefix}-moon`}>
        <span>Shoot the moon</span>
        <select
          id={`${idPrefix}-moon`}
          value={moonMode}
          disabled={disabled}
          onChange={(e) => patch({ moonMode: e.target.value })}
        >
          <option value="shoot_moon">+26 each opponent</option>
          <option value="subtract">−26 for shooter</option>
        </select>
      </label>
      <label className="spades-host-setting spades-host-setting--check">
        <input
          type="checkbox"
          checked={jackOfDiamondsBonus}
          disabled={disabled}
          onChange={(e) => patch({ jackOfDiamondsBonus: e.target.checked })}
        />
        <span>Jack of Diamonds is −10</span>
      </label>
    </div>
  );
}

export default HeartsSettingsFields;
